import * as __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__ from "date-fns";
function formatDuration(duration, options) {
    const { levels = 3, isShort = false } = options ?? {};
    const { years, months, weeks, days, hours, minutes } = duration;
    const start = years ? 0 : months ? 1 : weeks ? 2 : days ? 3 : hours ? 4 : minutes ? 5 : 6;
    const end = start + levels;
    const result = (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.formatDuration)(duration, {
        format: [
            'years',
            'months',
            'weeks',
            'days',
            'hours',
            'minutes',
            'seconds'
        ].slice(start, end),
        delimiter: ' '
    });
    return isShort ? result.replaceAll(/\s(year|month|week|day|hour|minute|second)s?/g, (match, unit)=>unit[0]?.toLocaleLowerCase() ?? '') : result;
}
export { formatDuration };

//# sourceMappingURL=format-duration.js.map